import React, { useEffect } from 'react';
import { QuestionIds } from 'onboarding/data/constants/QuestionIds';
import { Question } from 'onboarding/question/Question';
import { getQuestionsMeta } from 'onboarding/data/meta';
import { useFeatures } from 'useFeatures';
import { CreoQuizComponent } from 'onboarding/question/creoquiz/CreoQuizQuestion';
import { appAnalytics } from 'analytics';
import { ScreenOpened } from 'analytics/AllEvents';

export const CreoQuizWelcome: React.FC = () => {
  const {
    isAdhdTest,
    isDefaultOnboarding,
    isGadTest,
    isRecommendedByRmeqQ5Flow,
  } = useFeatures();

  const questionMeta = getQuestionsMeta(
    isAdhdTest,
    isDefaultOnboarding,
    isGadTest,
    isRecommendedByRmeqQ5Flow,
  );

  useEffect(() => {
    appAnalytics.trackEvent(new ScreenOpened('onboardingCreoQuiz'));
  }, []);

  const question: Question = questionMeta[QuestionIds.CreoQuizQ1];

  return <CreoQuizComponent question={question} />;
};
